import React, { useState, useEffect } from "react";
import Header from "../Section/Header";
import Footer from "../Section/Footer";
import {
  get_khudali_data,
  Kundli,
  server_post_data,
  like_dislike_msge_url,
  save_message_url,
} from "../../ServiceConnection/serviceconnection";
// Lucide icons
import {
  FileText,
  Sunrise,
  Compass,
  Timer,
  Orbit,
  Moon,
  Clock,
  Hash,
  Star,
  Handshake,
  HelpCircle,
  Calendar,
  UserRound,
  Eye,
  MessageCircle,
  MessageSquareReply,
  ThumbsUp,
  SendHorizontal,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { retrieveData } from "../../LocalConnection/LocalConnection";
import { CustomAlert, planetsData } from "../../CommonJquery/CustomAlert";
import ChartSection from "../Section/ChartSection";
import { formatDateStringdot } from "../../CommonJquery/CommonJquery";
import DashaModal from "../Section/DashaModal";
import { Button } from "react-bootstrap";
import FinalPayment from "./FinalPayment";
import Loader from "../Section/Loader";
export default function KundaliDetails({ click_from, page_name }) {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const isQuestionFlow = parseInt(click_from) === 3;
  const [activeTab, setActiveTab] = useState(isQuestionFlow ? 0 : 1);
  const [isMasked, setIsMasked] = useState(true);
  const [FinalDataPass, setFinalDataPass] = useState(null);
  const tabs = [
    {
      label: "Questions",
      icon: <HelpCircle className="w-4 h-4 mr-1" />,
    },
    { label: "Basic Info", icon: <FileText className="w-4 h-4 mr-1" /> },
    { label: "Lagna/Navmansha", icon: <Sunrise className="w-4 h-4 mr-1" /> },
    { label: "Dasha", icon: <Timer className="w-4 h-4 mr-1" /> },
    { label: "Transit", icon: <Orbit className="w-4 h-4 mr-1" /> },
    { label: "Moon", icon: <Moon className="w-4 h-4 mr-1" /> },
    { label: "Hora", icon: <Clock className="w-4 h-4 mr-1" /> },
    { label: "Dasmans", icon: <Hash className="w-4 h-4 mr-1" /> },
    { label: "Ashtvarga", icon: <Star className="w-4 h-4 mr-1" /> },
    { label: "Friendship", icon: <Handshake className="w-4 h-4 mr-1" /> },
  ];

  //:----------------------------------Set Dynamic Data:------------------
  const [isLoading, setIsLoading] = useState(false);
  const [lagna_chart_degree, setlagna_chart_degree] = useState([]);
  const [lagna_chart, setlagna_chart] = useState([]);
  const [navamsa_chart, setnavamsa_chart] = useState([]);
  const [dasamsa_chart, setdasamsa_chart] = useState([]);
  const [moon_chart, setmoon_chart] = useState([]);
  const [hora_chart, sethora_chart] = useState([]);
  const [transit_chart, settransit_chart] = useState([]);
  const [transit_chart_degree, settransit_chart_degree] = useState([]);
  const [dasa_degree, settdasa_degree] = useState([]);
  const [ashtavarga_degree, settashtavarga_degree] = useState([]);
  const [user_profile, set_user_profile] = useState([]);
  const [user_question, set_question] = useState([]);
  const [user_msg, set_msg] = useState([]);
  const [ReplyToName, setReplyToName] = useState(null); // Index of message being replied to
  const [replyText, setReplyText] = useState("");
  const [replyID, setreplyID] = useState("0");
  const [replyCDID, setreplyCDID] = useState("0");
  const [visibleNameIndex, setVisibleNameIndex] = useState(null);
  const [SelectedData, setSelectedData] = useState(null);
  const [SelectedDataDash, setSelectedDataDash] = useState(null);
  const [dasa_degreelevel, settdasa_degreelevel] = useState([]);
  const [dasa_degreeldata, settdasa_degreeldata] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalLevel, setModalLevel] = useState(1);
  const [DashaName, setDashaName] = useState("Dasa");
  const [DashaLevel, setDashaLevel] = useState(0);
  const [ShowStep2, setShowStep2] = useState(false);
  const [thread_id, setthread_id] = useState(0);
  const [question_data, setquestion_data] = useState("3");
  // Stack to keep track of modal data for back navigation
  const [modalStack, setModalStack] = useState([]);

  const master_data_get2 = async (user_question) => {
    const fd = new FormData();
    let date_spite = user_question.user_dob.split("-");
    let time_spite = user_question.user_dobtime.split(":");
    fd.append("name", user_question.user_name);
    fd.append("date", date_spite[2]);
    fd.append("month", date_spite[1]);
    fd.append("year", date_spite[0]);
    fd.append("hr", time_spite[0]);
    fd.append("min", time_spite[1]);
    fd.append("sec", time_spite[2]);
    fd.append("city", user_question.city_name);
    fd.append("longitude", formattedLatLong(user_question.longitude_data));
    fd.append("latitude", formattedLatLong(user_question.latitude_data));
    fd.append("state", user_question.state_name);
    fd.append("country", user_question.country_name);
    fd.append("sex", user_question.user_gender);
    fd.append("timeZoneId", user_question.time_zone_id);
    const customer_langauge = retrieveData("customer_langauge");
    fd.append(
      "english_hindi",
      customer_langauge !== "" ? customer_langauge : "1"
    );
    fd.append("level_call", 0);
    setIsLoading(true);
    await server_post_data(Kundli, fd)
      .then((Response) => {
        setlagna_chart(Response.lagna_chart);
        setlagna_chart_degree(Response.lagna_chart_degree);
        setnavamsa_chart(Response.navamsa_chart);
        sethora_chart(Response.hora_chart);
        setdasamsa_chart(Response.dasamsa_chart);
        setmoon_chart(Response.moon_chart);
        settransit_chart(Response.transit_chart);
        settransit_chart_degree(Response.transit_chart_degree);
        settdasa_degree(Response.dasa_degree);
        settashtavarga_degree(Response.ashtavarga_degree);
        Response.Birth_info.forEach((item) => {
          if (item.topicName === "Current Period") {
            setSelectedDataDash(item.topicInfo);
          }
        });
        set_user_profile(Response.Birth_info);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("this is error", error);
      });
  };

  const master_data_get_by_click = async (
    level_dasa,
    dasa_name,
    start_date,
    end_date
  ) => {
    try {
      setIsLoading(true);
      const fd = new FormData();
      let date_spite = user_question.user_dob.split("-");
      let time_spite = user_question.user_dobtime.split(":");
      fd.append("name", user_question.user_name);
      fd.append("date", date_spite[2]);
      fd.append("month", date_spite[1]);
      fd.append("year", date_spite[0]);
      fd.append("hr", time_spite[0]);
      fd.append("min", time_spite[1]);
      fd.append("sec", time_spite[2]);
      fd.append("city", user_question.city_name);
      fd.append("longitude", formattedLatLong(user_question.longitude_data));
      fd.append("latitude", formattedLatLong(user_question.latitude_data));
      fd.append("state", user_question.state_name);
      fd.append("country", user_question.country_name);
      fd.append("sex", user_question.user_gender);
      fd.append("timeZoneId", user_question.time_zone_id);
      const customer_langauge = retrieveData("customer_langauge");
      fd.append(
        "english_hindi",
        customer_langauge !== "" ? customer_langauge : "1"
      );
      settdasa_degreelevel([]);
      let level_save = parseInt(level_dasa) + 1;
      console.log(level_save);
      fd.append("level_call", level_save);
      fd.append("start_level_name", dasa_name);
      await server_post_data(Kundli, fd)
        .then((Response) => {
          if (Response.dasa_degree.length > 0) {
            // Save current state to stack before navigating forward
            const currentState = {
              dasa_degreelevel: dasa_degreelevel,
              dasa_degreeldata: dasa_degreeldata,
              DashaName: DashaName,
              DashaLevel: DashaLevel,
              modalLevel: modalLevel,
            };

            // Push current state to stack
            setModalStack((prevStack) => [...prevStack, currentState]);

            // Set new data for next level
            settdasa_degreelevel(Response.dasa_degree);
            settdasa_degreeldata(
              start_date + "     " + dasa_name + "      " + end_date
            );
            setDashaName(dasa_name);
            setDashaLevel(level_save);
            setModalLevel(level_save);
            setModalVisible(true);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log("this is error", error);
        });
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  // Function to handle opening modal from main screen
  const handleOpenModal = (level_dasa, dasa_name, start_date, end_date) => {
    // Set initial state in stack when opening modal from main screen
    const initialState = {
      dasa_degreelevel: dasa_degree, // Original dasa_degree data from props
      dasa_degreeldata: "Main Dasha Periods",
      DashaName: "Dasa",
      DashaLevel: 0,
      modalLevel: 1,
    };

    // Clear stack and set initial state
    setModalStack([initialState]);

    // Then call the API for next level
    master_data_get_by_click(level_dasa, dasa_name, start_date, end_date);
  };

  const handleBack = () => {
    if (modalStack.length > 0) {
      // Get the previous state from stack
      const previousState = modalStack[modalStack.length - 1];
      // Restore previous state
      settdasa_degreelevel(previousState.dasa_degreelevel);
      settdasa_degreeldata(previousState.dasa_degreeldata);
      setDashaName(previousState.DashaName);
      setDashaLevel(previousState.DashaLevel);
      setModalLevel(previousState.modalLevel);

      // Remove the last item from stack
      setModalStack((prevStack) => prevStack.slice(0, -1));
    } else {
      // If no previous state, close modal
      setModalVisible(false);
    }
  };
  const getMaskedName = (user_name) => {
    if (user_name) {
      if (user_name.length < 3) return user_name; // Not enough characters to mask
      const firstChar = user_name.charAt(0);
      const lastChar = user_name.charAt(user_name.length - 1);
      const stars = "*".repeat(user_name.length - 2);
      return `${firstChar}${stars}${lastChar}`;
    }
  };
  const master_data_get = async () => {
    const fd = new FormData();
    fd.append("current_url", "/" + currentUrl);
    fd.append("flag", click_from);
    setIsLoading(true);
    await server_post_data(get_khudali_data, fd)
      .then((Response) => {
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          let final_data = JSON.parse(data[1]);
          setIsLoading(false);
          console.log("Detail_data_response:-", final_data.khudali_data[0]);
          const fd = new FormData();
          let khudali_data = final_data.khudali_data[0];
          let khudali_data_msg = [];
          if (final_data.khudali_data_msg) {
            khudali_data_msg = final_data.khudali_data_msg;
            setthread_id(khudali_data.threads_id);
            setquestion_data(khudali_data.title);
            set_msg(khudali_data_msg);
          }

          set_question(khudali_data);

          master_data_get2(khudali_data);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("this is error", error);
      });
  };

  const handleSendReply = async () => {
    let msg = "";
    if (!replyText.trim()) {
      msg = "Please enter your Reply";
    }
    if (msg === "") {
      setIsLoading(true);
      const fdddd = new FormData();
      fdddd.append("reply_cd_id", replyCDID);
      fdddd.append("reply_id", replyID);
      fdddd.append("thread_idd", user_question.threads_id);
      fdddd.append("cat_idd", user_question.cat_id);
      fdddd.append("messages", replyText);
      await server_post_data(save_message_url, fdddd)
        .then((Response) => {
          setIsLoading(false);
          const data = Response.split("~@~");
          if (Number.parseInt(data[0]) === 1) {
            CustomAlert("Error", data[1]);
          } else {
            CustomAlert("message", data[1]);
            setReplyText("");
            setSelectedData(null);
            setreplyID(0);
            setreplyCDID(0);
            master_data_get();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log("nsjkc", error);
        });
    } else {
      CustomAlert("Error", msg);
    }
  };

  const handlelikedislkieReply = async (like_dislike, msg_idd) => {
    setIsLoading(true);

    const fd = new FormData();
    fd.append("like_dislike", like_dislike);
    fd.append("msg_idd", msg_idd);
    await server_post_data(like_dislike_msge_url, fd)
      .then((Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          const actionMessage =
            like_dislike === "1"
              ? "You have liked the message"
              : "You have unliked the message";
          CustomAlert("Message", actionMessage);
          master_data_get();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const replyonthemsg = async (item, full_name) => {
    setSelectedData(item);
    setreplyID(item.msg_id);
    setreplyCDID(item.person_id);
    setReplyToName(full_name);
    setReplyText("");
  };

  const replyonthemsgclose = async () => {
    setSelectedData(null);
    setreplyID(0);
    setreplyCDID(0);
    setReplyToName(null);
    setReplyText("");
  };

  const formattedLatLong = (originalValue) => {
    const multipliedValue = originalValue * 100;
    const roundedValue = Math.floor(multipliedValue);
    return roundedValue / 100;
  };

  useEffect(() => {
    master_data_get();
  }, []);

  useEffect(() => {
    console.log("rander");
  }, [user_question, user_msg]);

  const handleNavigate = () => {
    const fd = new FormData();
    fd.append("male_name", user_question.user_name);
    fd.append("male_dob", user_question.user_dob);
    fd.append("male_dobtime", user_question.user_dobtime);
    fd.append("male_city_name", user_question.city_name);
    fd.append("male_state_name", user_question.state_name);
    fd.append("male_country_name", user_question.country_name);
    fd.append(
      "male_latitude_data",
      formattedLatLong(user_question.latitude_data)
    );
    fd.append(
      "male_longitude_data",
      formattedLatLong(user_question.longitude_data)
    );
    fd.append("user_gender", user_question.user_gender);
    fd.append("male_time_zone_id", user_question.time_zone_id);
    fd.append("question_1", question_data);
    fd.append("female_name", "");
    fd.append("female_dob", "");
    fd.append("female_dobtime", "");
    fd.append("female_city_name", "");
    fd.append("female_state_name", "");
    fd.append("female_country_name", "");
    fd.append("female_latitude_data", "");
    fd.append("female_longitude_data", "");
    fd.append("female_time_zone_id", "");
    fd.append("astrology_id", "0");
    fd.append("thread_id", thread_id);
    fd.append("astrology_name", "");

    fd.append("category_name", page_name);
    setFinalDataPass(fd);
    setShowStep2(true);
  };
  return (
    <>
      <Header />
      {isLoading && <Loader />}
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section className="max-w-6xl mx-auto py-4 px-2 lg:py-10 lg:px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4">
              ⭐ Kundli
            </h2>
            <p className="text-lg text-[var(--light-pink-color)]">
              View complete astrological insights of your birth chart
            </p>
          </div>

          {/* Scrollable Tabs */}
          {!ShowStep2 && (
            <>
              <div className="overflow-x-auto no-scrollbar">
                <div className="flex whitespace-nowrap justify-center gap-4 lg:gap-6 mb-6 border-b border-white/20 px-1 min-w-max mt-3">
                  {tabs.map((tab, index) => {
                    if (!isQuestionFlow && index === 0) return null;

                    return (
                      <button
                        key={index}
                        onClick={() => setActiveTab(index)}
                        className={`flex items-center pb-2 border-b-2 transition-all duration-300 font-medium text-sm md:text-base ${
                          activeTab === index
                            ? "border-[var(--primary-color)] text-[var(--white)]"
                            : "border-transparent text-[var(--light-pink-color)] kundali_tabs"
                        }`}
                      >
                        {tab.icon}
                        {tab.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Tab Content */}
              <div className="flex justify-center mt-1 text-white space-y-4">
                {/**---------Basio Info tab ------------*/}
                {activeTab === 0 && (
                  <div className="flex flex-col gap-6">
                    {/* Top section: User Info + Question */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                      {/* User Info */}
                      <div className="rounded-xl bg-slate-800/60 backdrop-blur-md p-4 shadow-md border border-yellow-400/30 ">
                        <div>
                          <p className="text-white font-semibold flex items-center gap-2 mb-1">
                            <UserRound size={18} /> Name:{" "}
                            {isMasked
                              ? getMaskedName(user_question.user_name)
                              : user_question.user_name}{" "}
                            <button
                              onClick={() => setIsMasked(!isMasked)}
                              className="text-sm text-purple-400 hover:underline"
                            >
                              {isMasked ? "Show" : "Hide"}
                            </button>
                          </p>
                          <p className="text-sm text-gray-300 mb-0.5">
                            DOB: {user_question.user_dob}| Time:{" "}
                            {user_question.user_dobtime}
                          </p>
                          <p className="text-sm text-gray-300">
                            Place: {user_question.city_name},
                            {user_question.state_name},
                            {user_question.country_name}
                          </p>
                        </div>
                        <div className="w-full flex justify-end mt-2">
                          <button
                            className="cursor-pointer items-center gap-1 border border-purple-200 bg-purple-50 text-[var(--primary-color)] px-[18px] py-1.5 rounded-lg font-medium text-[15px] hover:bg-[--primary-hover-dark] hover:text-white transition"
                            onClick={() => setActiveTab(1)}
                          >
                            View Chart
                          </button>
                        </div>
                      </div>

                      {/* Question */}
                      <div className="rounded-xl bg-slate-800/60 backdrop-blur-md p-4 shadow-md border border-yellow-400/30 ">
                        <p className="text-white font-medium mb-3 text-lg">
                          <strong>Question:</strong> {user_question.title}
                        </p>
                        <p className="text-sm text-gray-300 flex items-center flex-wrap gap-4">
                          <span className="flex items-center gap-1">
                            <Calendar size={16} />
                            {formatDateStringdot(user_question.entry_date)}
                          </span>
                          <span className="flex items-center gap-1">
                            <Eye size={16} /> {user_question.total_views} Views
                          </span>
                          <span className="flex items-center gap-1">
                            <MessageCircle size={16} />{" "}
                            {user_question.total_message} Replies
                          </span>
                        </p>
                        <div className="w-full flex justify-end mt-3">
                          <Button
                            variant="warning"
                            className="bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] hover:text-[var(--light-pink-color)] border-none text-[var(--light-pink-color)] font-semibold text-[15px] px-4 py-2 rounded float-right mb-0"
                            onClick={handleNavigate}
                          >
                            Need Consultation ?
                          </Button>
                        </div>
                      </div>
                    </div>

                    {/* Answer Section */}
                    {user_msg?.map((msg, index) => (
                      <div
                        key={index}
                        className="rounded-xl bg-slate-800/60 p-6 mb-6 border border-yellow-400/30"
                      >
                        <div className="mb-4">
                          <p className="text-white font-semibold mb-1 text-base">
                            <strong>Answer:</strong>{" "}
                            {visibleNameIndex === index
                              ? msg.full_name2
                              : getMaskedName(msg.full_name2)}{" "}
                            <button
                              onClick={() =>
                                setVisibleNameIndex(
                                  visibleNameIndex === index ? null : index
                                )
                              }
                              className="text-sm text-purple-400 hover:underline pointer"
                            >
                              {visibleNameIndex === index ? "Hide" : "Show"}
                            </button>
                          </p>
                          <p className="text-gray-300 text-sm">
                            {msg.messages}
                          </p>
                        </div>

                        <div className="flex justify-between items-center text-sm text-gray-400 mt-6">
                          <span className="flex items-center gap-3">
                            <Calendar size={16} />{" "}
                            {formatDateStringdot(msg.entry_date)}
                            <p
                              className="flex items-center gap-1 pointer"
                              onClick={() =>
                                handlelikedislkieReply(
                                  msg.like_count,
                                  msg.msg_id
                                )
                              }
                            >
                              <ThumbsUp size={16} /> {msg.like_count} likes
                            </p>
                          </span>

                          <button
                            onClick={() => {
                              replyonthemsg(msg, msg.full_name2);
                            }}
                            className="cursor-pointer border border-purple-200 bg-purple-50 text-[var(--primary-color)] px-[27px] py-1.5 rounded-lg font-medium text-[15px] hover:bg-[--primary-hover-dark] hover:text-white transition pointer"
                          >
                            Reply
                          </button>
                        </div>
                      </div>
                    ))}

                    {/* Reply Input */}
                    <div className="mt-6">
                      <p className="text-white font-semibold text-base mb-2">
                        {ReplyToName !== null
                          ? `Replying to message #${ReplyToName}`
                          : "Write a new reply"}
                      </p>

                      <textarea
                        rows="4"
                        value={replyText}
                        onChange={(e) => setReplyText(e.target.value)}
                        placeholder="Write your reply..."
                        className="w-full p-3 rounded-lg bg-slate-700 text-white border border-yellow-400 focus:outline-none resize-none"
                      ></textarea>

                      <div className="flex justify-between items-center mt-3">
                        <button
                          onClick={() => {
                            replyonthemsgclose();
                          }}
                          className="text-sm text-gray-400 hover:underline pointer"
                        >
                          Cancel
                        </button>

                        <button
                          onClick={handleSendReply}
                          className="flex items-center gap-2 border border-purple-200 bg-purple-50 text-[var(--primary-color)] px-[27px] py-2 rounded-lg font-medium text-[15px] hover:bg-[--primary-hover-dark] hover:text-white transition pointer"
                        >
                          <SendHorizontal size={16} /> Send
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === 1 && (
                  <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-4xl">
                    <h3 className="text-xl font-semibold text-[var(--secondary-color)] mb-4 border-b border-[var(--secondary-color)] pb-6">
                      📄 Birth Details{" "}
                      <Button
                        variant="warning"
                        className="bg-[var(--secondary-color)] hover:bg-[var(--primary-hover-dark)] hover:text-[var(--light-pink-color)] border-none text-[var(--light-pink-color)] font-semibold text-[15px] px-4 py-2 rounded float-right mb-0"
                        onClick={handleNavigate}
                      >
                        Need Consultation ?
                      </Button>
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-[1.2rem] text-gray-800">
                      {user_profile.map((item, index) => (
                        <div key={index}>
                          <p className="text-sm text-purple-600">
                            {item.topicName}
                          </p>
                          <p className="text-[16px] font-medium">
                            {item.topicInfo}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/**--------Lagda / Namavsha  tab ------------*/}
                {activeTab === 2 && (
                  <div className="overflow-hidden px-2">
                    <div className="flex flex-col lg:flex-row gap-2 items-center justify-center">
                      <div className="w-full">
                        <ChartSection
                          title="Lagna"
                          data_chart={lagna_chart}
                          data_list={null}
                        />
                      </div>

                      <div className="w-full">
                        <ChartSection
                          title="Navamsa"
                          data_chart={navamsa_chart}
                          data_list={null}
                        />
                      </div>
                    </div>
                    <ChartSection
                      data_chart={null}
                      data_list={lagna_chart_degree}
                    />{" "}
                  </div>
                )}

                {/**---------Dasha tab ------------*/}
                {activeTab === 3 && (
                  <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-4xl overflow-x-auto">
                    <h3 className="text-xl font-semibold text-[var(--secondary-color)] mb-4 pb-2 border-b border-[var(--secondary-color)]">
                      🕰️ Dasha Periods
                    </h3>
                    {dasa_degree.length === 0 ? (
                      <p className="text-center text-purple-500 py-10 bg-purple-50 rounded-md">
                        No Dasha data found.
                      </p>
                    ) : (
                      <table className="w-full text-sm text-center text-gray-800 min-w-[400px]">
                        <thead>
                          <tr className="text-purple-700">
                            <th className="py-3 pr-4 px-2 text-center">
                              Start Date
                            </th>
                            <th className="py-3 pr-4 px-2 text-center">
                              Dasha
                            </th>
                            <th className="py-3 px-2 text-center">End Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dasa_degree.map((item, index) => (
                            <tr
                              key={index}
                              onClick={() =>
                                handleOpenModal(
                                  item.level_dasa,
                                  item.dasa,
                                  item.statdate,
                                  item.endDate
                                )
                              }
                              className={`${
                                SelectedDataDash.startsWith(item.dasa)
                                  ? "bg-orange-300"
                                  : index % 2 === 0
                                  ? "bg-gray-100"
                                  : "bg-gray-50"
                              }
                               hover:bg-purple-100 cursor-pointer transition-all duration-200`}
                            >
                              <td className="py-3 px-2 pr-4 text-center">
                                {item.statdate}
                              </td>
                              <td className="py-3 px-2 pr-4 text-center">
                                {item.dasa}
                              </td>
                              <td className="py-3 px-2 pr-4 text-center">
                                {item.endDate}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    {isModalVisible && (
                      <DashaModal
                        isVisible={isModalVisible}
                        handleClose={() => setModalVisible(false)}
                        handleBack={handleBack}
                        dasa_degreeldata={dasa_degreeldata}
                        DashaName={DashaName}
                        SelectedDataDash={SelectedDataDash}
                        dasa_degreelevel={dasa_degreelevel}
                        master_data_get_by_click={master_data_get_by_click}
                        modalLevel={modalLevel}
                      />
                    )}
                  </div>
                )}

                {/**---------Transit tab ------------*/}
                {activeTab === 4 && (
                  <div className=" flex flex-col items-center justify-center w-[100%] TransitCutmPositions">
                    <ChartSection
                      title="Transit"
                      data_chart={transit_chart}
                      data_list={transit_chart_degree}
                    />
                  </div>
                )}
                {/**---------Moon tab ------------*/}
                {activeTab === 5 && (
                  <ChartSection
                    title="Moon"
                    data_chart={moon_chart}
                    data_list={null}
                  />
                )}
                {/**---------Hora tab ------------*/}
                {activeTab === 6 && (
                  <div className=" flex flex-col items-center justify-center w-[100%] HoraTabCusmPos">
                    <ChartSection
                      title="Hora"
                      data_chart={hora_chart}
                      data_list={null}
                    />
                  </div>
                )}
                {/*------------Dasmans Tab------- */}
                {activeTab === 7 && (
                  <ChartSection
                    title="Dasmans"
                    data_chart={dasamsa_chart}
                    data_list={null}
                  />
                )}
                {activeTab === 8 && (
                  <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-5xl overflow-x-auto">
                    <h3 className="text-xl font-semibold text-[var(--secondary-color)] mb-4 border-b border-[var(--secondary-color)] pb-2">
                      🌟 Ashtvarga Table
                    </h3>
                    {ashtavarga_degree.length === 0 ? (
                      <p className="text-center text-purple-400 py-10">
                        No Ashtvarga data found.
                      </p>
                    ) : (
                      <table className="w-full text-sm text-left text-gray-800 min-w-[400px]">
                        <thead>
                          {ashtavarga_degree
                            .filter((_, index) => index === 0)
                            .map((item, index) => (
                              <tr key={index} className="text-purple-700">
                                <th className="py-3 px-4  text-center">
                                  {item.position_sun}
                                </th>
                                <th className="py-3 px-4  text-center">
                                  {item.position_moon}
                                </th>
                                <th className="py-3 px-4  text-center">
                                  {item.position_mars}
                                </th>
                                <th className="py-3 px-4  text-center">
                                  {item.position_mercury}
                                </th>
                                <th className="py-3 px-4  text-center">
                                  {item.position_jupiter}
                                </th>
                                <th className="py-3 px-4  text-center">
                                  {item.position_venus}
                                </th>
                                <th className="py-3 px-4  text-center">
                                  {item.position_saturn}
                                </th>
                                <th className="py-3 px-4  text-center">
                                  {item.position_total}
                                </th>
                              </tr>
                            ))}
                        </thead>
                        <tbody>
                          {ashtavarga_degree
                            .filter((_, index) => index !== 0)
                            .map((item, index) => (
                              <tr
                                key={index}
                                className={`${
                                  index % 2 === 0 ? "bg-gray-100" : "bg-gray-50"
                                } hover:bg-purple-100 transition-all duration-200`}
                              >
                                <td className="py-3 px-2 pr-4 text-center">
                                  {item.position_sun}
                                </td>
                                <td className="py-3 px-2 pr-4 text-center">
                                  {item.position_moon}
                                </td>
                                <td className="py-3 px-2 pr-4 text-center">
                                  {item.position_mars}
                                </td>
                                <td className="py-3 px-2 pr-4 text-center">
                                  {item.position_mercury}
                                </td>
                                <td className="py-3 px-2 pr-4 text-center">
                                  {item.position_jupiter}
                                </td>
                                <td className="py-3 px-2 pr-4 text-center">
                                  {item.position_venus}
                                </td>
                                <td className="py-3 px-2 pr-4 text-center">
                                  {item.position_saturn}
                                </td>
                                <td className="py-3 px-2 pr-4 text-center">
                                  {parseInt(item.position_sun) +
                                    parseInt(item.position_moon) +
                                    parseInt(item.position_mars) +
                                    parseInt(item.position_mercury) +
                                    parseInt(item.position_jupiter) +
                                    parseInt(item.position_venus) +
                                    parseInt(item.position_saturn)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}

                {activeTab === 9 && (
                  <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-5xl overflow-x-auto">
                    <h3 className="text-xl font-semibold text-purple-700 mb-4 border-b border-purple-200 pb-2">
                      🤝 Planetary Friendship Table
                    </h3>
                    {planetsData.length === 0 ? (
                      <p className="text-center text-purple-400 py-10">
                        No Friendship data found.
                      </p>
                    ) : (
                      <table className="w-full text-sm text-left text-gray-800 min-w-[400px]">
                        <thead>
                          <tr className="text-purple-700">
                            <th className="py-3 px-4  text-center">Planet</th>
                            <th className="py-3 px-4  text-center">Friends</th>
                            <th className="py-3 px-4  text-center">Enemies</th>
                            <th className="py-3 px-4  text-center">Neutral</th>
                          </tr>
                        </thead>
                        <tbody>
                          {planetsData.map((item, index) => (
                            <tr
                              key={index}
                              className={`${
                                index % 2 === 0 ? "bg-gray-100" : "bg-gray-50"
                              } hover:bg-purple-100 transition-all duration-200`}
                            >
                              <td className="py-3 px-2 pr-4 text-center">
                                {item.Planet}
                              </td>
                              <td className="py-3 px-2 pr-4 text-center">
                                {item.Friends.join(", ")}
                              </td>
                              <td className="py-3 px-2 pr-4 text-center">
                                {item.Enemies.join(", ")}
                              </td>
                              <td className="py-3 px-2 pr-4 text-center">
                                {item.Neutral.join(", ")}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
          {ShowStep2 && (
            <FinalPayment FinalDataPass={FinalDataPass} Page_Name={page_name} />
          )}
        </section>
      </div>
      <Footer />
    </>
  );
}
